<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import {mapGetters, mapActions, mapState} from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Factory stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Factory stock",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "factory.name",
          sortable: true,
          label: "FACTORY",
        },
        {
          key: "name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "movements",
          sortable: true,
          label: "MOVEMENTS",
        },
      ],

    filterStock:{
        factory: 0
    },

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("factorystock", ["FilterStatus","FactoryStock","ProductionFactories"]),
    ...mapGetters("auth", ["MyUserPerm","business","branch"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.FactoryStock ? this.FactoryStock.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FactoryStock ? this.FactoryStock.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
        FetchFactoryStock: "factorystock/fetchFactorystock",
        FetchFactories: "factorystock/fetchProductionFactories",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
   
    
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        let xx = m.toString().split(".");
        let x1=xx[0]
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (!xx[1]){
            if(m.toString().charAt(m.length - 1) == '.'){
            return x1+".";
             
            }else{
                return x1;

            }
        }else{
          return x1+"."+xx[1];
        }
      } else {
        return m;
      }
    },

    FilterFactoriestock(){
        this.FetchFactoryStock(this.filterStock.factory);
    },

    redirect(product,factory) {
      this.$router.push(
          `/factory_stock/stock_movements/${btoa(product)}/${btoa(factory)}`
      );
    },
  },
  created() {
    this.FetchFactories();
    this.FetchFactoryStock(this.filterStock.factory);
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{business}} - {{branch}}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-5">
                <div class="col-md-7 form-group mb-2"></div>                              
                <div class="col-md-3 form-group">
                <label>SEARCH FOR FACTORY</label>
                
                <model-list-select
                    :list="ProductionFactories ? ProductionFactories : []"
                    v-model="filterStock.factory"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Factory"
                    @input="FilterFactoriestock()"
                >
                </model-list-select>
                </div>                
                <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="FilterFactoriestock()">
                <span class="fa fa-filter"></span> Filter
                <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                ></b-spinner>
                </button>
            </div>
            </div> 
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Factory Stock Level In Different Units</h4>
              </div>

            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="FactoryStock?FactoryStock:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(buying_p)="data">
                  <span class="text-warning"
                        v-b-modal.expired-modal
                        @click="ShowEdit(data.item)">
                    {{ thousandSeperator(data.item.stock.buying_price) }}
                  </span>

                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <thead>
                    <tr width="100%">
                      <th>IN STOCK</th>
                      <th>SELLING PRICE</th>
                      <th>RESERVE PRICE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr width="100%">
                      <td>{{ Math.floor(data.item.instock/data.item.units[0].base_qty)  }} {{ data.item.units[0].unit.name }}</td>
                      <td>{{ thousandSeperator(data.item.units[0].selling) }}</td>
                      <td>{{ thousandSeperator(data.item.units[0].reserve) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(movements)="data">
                  <b-button
                      size="sm"
                      variant="success"
                      @click="redirect(data.item.product_id, data.item.factory.id)"
                  ><i class="fa fa-retweet"></i>Movements</b-button>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!FactoryStock"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
